<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="typeSelectItems"
            v-model="item.type"
            :items="typeSelectItems"
            :error-messages="typeErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.producttypefiletype')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-file-input
            v-model="item.file"
            :error-messages="fileErrors"
            :label="$t('global.fileinput')"
            show-size
            required
            @input="$v.item.file.$touch()"
            @blur="$v.item.file.$touch()"
          ></v-file-input>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-model="item.language"
            :items="languages"
            :error-messages="languageErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('global.language')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('profile.public') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.public"
                :error-messages="publicErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
        </v-col>
      </v-row>

     <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="machineSelectItems"
            v-model="item.machine"
            :items="machineSelectItems"
            :error-messages="machineErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.machine.machine')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="controlUnitSelectItems"
            v-model="item.controlUnit"
            :items="controlUnitSelectItems"
            :error-messages="controlUnitErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.controlunit.controlunit')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="industrialComputerSelectItems"
            v-model="item.industrialComputer"
            :items="industrialComputerSelectItems"
            :error-messages="industrialComputerErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.industrialcomputer.industrialcomputer')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="operatingSystemSelectItems"
            v-model="item.operatingSystem"
            :items="operatingSystemSelectItems"
            :error-messages="operatingSystemErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.operatingsystem.operatingsystem')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="softwareVersionSelectItems"
            v-model="item.softwareVersion"
            :items="softwareVersionSelectItems"
            :error-messages="softwareVersionErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.software.software')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialSupplySelectItems"
            v-model="item.materialSupply"
            :items="materialSupplySelectItems"
            :error-messages="materialSupplyErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('qualitycheck.product.materialsupply')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="toolHeadSelectItems"
            v-model="item.toolHead"
            :items="toolHeadSelectItems"
            :error-messages="toolHeadErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.tool.toolhead')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="optionSelectItems"
            v-model="item.optionMachine"
            :items="optionSelectItems"
            :error-messages="optionMachineErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.option.option')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="accessorySelectItems"
            v-model="item.accessory"
            :items="accessorySelectItems"
            :error-messages="accessoryErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.accessory.accessory')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialProductVersionSelectItems"
            v-model="item.materialProductVersion"
            :items="materialProductVersionSelectItems"
            :error-messages="materialProductVersionErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.material.productversion')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Loading from '../../components/Loading';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';


import { maxsizefile } from '../../utils/files';

export default {
  name: 'ProducttypefileForm',
  mixins: [validationMixin],
  components: {
    Loading,
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.typeGetSelectItems();
      this.controlUnitGetSelectItems();
      this.machineGetSelectItems();
      this.industrialComputerGetSelectItems();
      this.operatingSystemGetSelectItems();
      this.softwareVersionGetSelectItems();
      this.materialSupplyGetSelectItems();
      this.toolHeadGetSelectItems();
      this.optionGetSelectItems();
      this.accessoryGetSelectItems();
      this.materialProductVersionGetSelectItems();
      
  },
  data() {
    return {
        name: null,
        public: null,
        type: null,
        file: null,
        language: null,
        controlUnit: null,
        machine: null,
        industrialComputer: null,
        operatingSystem: null,
        softwareVersion: null,
        materialSupply: null,
        toolHead: null,
        optionMachine: null,
        accessory: null,
        materialProductVersion: null,  
    };
  },
  computed: {
    isLoading() {
      return (
      this.isLoading_type ||
      this.isLoading_controlUnit ||
      this.isLoading_machine ||
      this.isLoading_industrialComputer ||
      this.isLoading_operatingSystem ||
      this.isLoading_softwareVersion ||
      this.isLoading_materialSupply ||
      this.isLoading_toolHead ||
      this.isLoading_option ||
      this.isLoading_accessory ||
      this.isLoading_materialProductVersion
      

       );
    },
    ...mapFields('producttypefiletype', {
      typeSelectItems: 'selectItems',
      isLoading_type : 'isLoading'
    }),
    ...mapFields('controlunit', {
      controlUnitSelectItems: 'selectItems',
      isLoading_controlUnit : 'isLoading'
    }),
    ...mapFields('machine', {
      machineSelectItems: 'selectItems',
      isLoading_machine : 'isLoading'
    }),
    ...mapFields('industrialcomputer', {
      industrialComputerSelectItems: 'selectItems',
      isLoading_industrialComputer : 'isLoading'
    }),
    ...mapFields('operatingsystem', {
      operatingSystemSelectItems: 'selectItems',
      isLoading_operatingSystem : 'isLoading'
    }),
    ...mapFields('softwareversion', {
      softwareVersionSelectItems: 'selectItems',
      isLoading_softwareVersion : 'isLoading'
    }),
    ...mapFields('materialsupply', {
      materialSupplySelectItems: 'selectItems',
      isLoading_materialSupply : 'isLoading'
    }),
    ...mapFields('toolhead', {
      toolHeadSelectItems: 'selectItems',
      isLoading_toolHead : 'isLoading'
    }),
    ...mapFields('option', {
      optionSelectItems: 'selectItems',
      isLoading_option : 'isLoading'
    }),
    ...mapFields('accessory', {
      accessorySelectItems: 'selectItems',
      isLoading_accessory : 'isLoading'
    }),
    ...mapFields('materialproductversion', {
      materialProductVersionSelectItems: 'selectItems',
      isLoading_materialProductVersion : 'isLoading'
    }),

    

    languages() {
      //return [{ name : 'en' }, { name : 'fr' }];
      return ['all','en', 'fr'];
    },
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    typeErrors() {
      const errors = [];

      if (!this.$v.item.type.$dirty) return errors;

      has(this.violations, 'type') && errors.push(this.violations.type);

      !this.$v.item.type.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    fileErrors() {
      const errors = [];

      if (!this.$v.item.file.$dirty) return errors;

      has(this.violations, 'file') && errors.push(this.violations.file);

      !this.$v.item.file.maxsizefile && errors.push(this.$t('global.maxsize'));
      return errors;
    },
    languageErrors() {
      const errors = [];
      if (!this.$v.item.language.$dirty) return errors;
      has(this.violations, 'language') && errors.push(this.violations.language);
      return errors;
    },
    publicErrors() {
      const errors = [];
      if (!this.$v.item.public.$dirty) return errors;
      has(this.violations, 'public') && errors.push(this.violations.public);
      return errors;
    },
    controlUnitErrors() {
      const errors = [];
      if (!this.$v.item.controlUnit.$dirty) return errors;
      has(this.violations, 'controlUnit') && errors.push(this.violations.controlUnit);
      return errors;
    },
    machineErrors() {
      const errors = [];
      if (!this.$v.item.machine.$dirty) return errors;
      has(this.violations, 'machine') && errors.push(this.violations.machine);
      return errors;
    },
    industrialComputerErrors() {
      const errors = [];
      if (!this.$v.item.industrialComputer.$dirty) return errors;
      has(this.violations, 'industrialComputer') && errors.push(this.violations.industrialComputer);
      return errors;
    },
    operatingSystemErrors() {
      const errors = [];
      if (!this.$v.item.operatingSystem.$dirty) return errors;
      has(this.violations, 'operatingSystem') && errors.push(this.violations.operatingSystem);
      return errors;
    },
    softwareVersionErrors() {
      const errors = [];
      if (!this.$v.item.softwareVersion.$dirty) return errors;
      has(this.violations, 'softwareVersion') && errors.push(this.violations.softwareVersion);
      return errors;
    },
    materialSupplyErrors() {
      const errors = [];
      if (!this.$v.item.materialSupply.$dirty) return errors;
      has(this.violations, 'materialSupply') && errors.push(this.violations.materialSupply);
      return errors;
    },
    toolHeadErrors() {
      const errors = [];
      if (!this.$v.item.toolHead.$dirty) return errors;
      has(this.violations, 'toolHead') && errors.push(this.violations.toolHead);
      return errors;
    },
    optionMachineErrors() {
      const errors = [];
      if (!this.$v.item.optionMachine.$dirty) return errors;
      has(this.violations, 'optionMachine') && errors.push(this.violations.optionMachine);
      return errors;
    },
    accessoryErrors() {
      const errors = [];
      if (!this.$v.item.accessory.$dirty) return errors;
      has(this.violations, 'accessory') && errors.push(this.violations.accessory);
      return errors;
    },
    materialProductVersionErrors() {
      const errors = [];
      if (!this.$v.item.materialProductVersion.$dirty) return errors;
      has(this.violations, 'materialProductVersion') && errors.push(this.violations.materialProductVersion);
      return errors;
    },

    



    violations() {
      return this.errors || {};
    }
  },
  methods: {
    ...mapActions({
      typeGetSelectItems: 'producttypefiletype/fetchSelectItems'
    }),
    ...mapActions({
      controlUnitGetSelectItems: 'controlunit/fetchSelectItems'
    }),
    ...mapActions({
      machineGetSelectItems: 'machine/fetchSelectItems'
    }),
    ...mapActions({
      industrialComputerGetSelectItems: 'industrialcomputer/fetchSelectItems'
    }),
    ...mapActions({
      operatingSystemGetSelectItems: 'operatingsystem/fetchSelectItems'
    }),
    ...mapActions({
      softwareVersionGetSelectItems: 'softwareversion/fetchSelectItems'
    }),
    ...mapActions({
      materialSupplyGetSelectItems: 'materialsupply/fetchSelectItems'
    }),
    ...mapActions({
      toolHeadGetSelectItems: 'toolhead/fetchSelectItems'
    }),
    ...mapActions({
      optionGetSelectItems: 'option/fetchSelectItems'
    }),
    ...mapActions({
      accessoryGetSelectItems: 'accessory/fetchSelectItems'
    }),
    ...mapActions({
      materialProductVersionGetSelectItems: 'materialproductversion/fetchSelectItems'
    }),
    


  },
  validations: {
    item: {
      name: {
        required,
      },
      type: {
        required,
      },
      file: {
        required,
        maxsizefile : maxsizefile(500),
      },
      language: {
      },
      public: {
      },
      controlUnit: {
      },
      machine: {
      },
      industrialComputer: {
      },
      operatingSystem: {
      },
      softwareVersion: {
      },
      materialSupply: {
      },
      toolHead: {
      },
      optionMachine: {
      },
      accessory: {
      },
      materialProductVersion: {
      },
    }
  }
};
</script>